import React from "react";
import Container from "@mui/material/Container";

export default function ContainerNav(props) {
  const style = {
    display: "flex",
    flexDirection: "row",
    padding: "20px",
    justifyContent: "space-evenly",
    alignContent: "center",
    backgroundColor: "#f5f5f5",
    height: "10vh",
    // flexWrap: "wrap",
    alignItems: "center",
    position: "fixed",
    bottom: "0",
  };
  return <Container style={style}>{props.children}</Container>;
}
